import { useEffect, useState } from "react";
import AssignVehicleModal from "./AssignVehicleModal";
import ReassignVehicleModal from "./ReassignVehicleModal";
import { hasAssignedVehicle } from "./routeVehicleModalUtils";

const EditRouteMaster = ({ showModal, setShowModal, editRow }) => {
  const [isReassignMode, setIsReassignMode] = useState(false);

  useEffect(() => {
    if (!showModal) return;
    setIsReassignMode(hasAssignedVehicle(editRow));
  }, [showModal, editRow]);

  if (isReassignMode) {
    return (
      <ReassignVehicleModal
        showModal={showModal}
        setShowModal={setShowModal}
        editRow={editRow}
      />
    );
  }

  return (
    <AssignVehicleModal
      showModal={showModal}
      setShowModal={setShowModal}
      editRow={editRow}
    />
  );
};

export default EditRouteMaster;
